/*==================================================
  PRODUCT TABS
==================================================*/

document.addEventListener("DOMContentLoaded", function () {

    /*--------------------------------------
      Desktop Tabs
    --------------------------------------*/

    const tabButtons = document.querySelectorAll(".product-tab-btn");
    const tabPanes = document.querySelectorAll(".product-tab-pane");

    if (tabButtons.length) {

        function openTab(id) {

            tabButtons.forEach(btn => {
                btn.classList.remove("active");
            });

            tabPanes.forEach(pane => {
                pane.classList.remove("active");
            });

            const activeButton = document.querySelector(
                '.product-tab-btn[data-tab="' + id + '"]'
            );

            const activePane = document.getElementById(id);

            if (activeButton) activeButton.classList.add("active");
            if (activePane) activePane.classList.add("active");

            history.replaceState(null, null, "#" + id);

        }

        tabButtons.forEach(btn => {

            btn.addEventListener("click", function () {

                openTab(this.dataset.tab);

            });

        });

        if (window.location.hash) {

            const hash = window.location.hash.replace("#", "");

            if (document.getElementById(hash)) {

                openTab(hash);

            }

        } else {

            openTab(tabButtons[0].dataset.tab);

        }

    }

    /*--------------------------------------
      Mobile Accordion
    --------------------------------------*/

    const accordionItems = document.querySelectorAll(".accordion-item");

    accordionItems.forEach(item => {

        const title = item.querySelector(".accordion-title");

        title.addEventListener("click", function () {

            accordionItems.forEach(i => {

                if (i !== item) {

                    i.classList.remove("active");

                }

            });

            item.classList.toggle("active");

        });

    });

    if (accordionItems.length) {

        accordionItems[0].classList.add("active");

    }

    /*--------------------------------------
      Smooth Scroll For Hash
    --------------------------------------*/

    if (window.location.hash) {

        setTimeout(function () {

            const wrapper = document.querySelector(".product-tabs-wrapper");

            if (wrapper) {

                wrapper.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

            }

        }, 200);

    }

    /*--------------------------------------
      Auto Scroll Active Button
    --------------------------------------*/

    function scrollActiveTab() {

        const active = document.querySelector(".product-tab-btn.active");

        if (!active) return;

        active.scrollIntoView({

            behavior: "smooth",
            inline: "center",
            block: "nearest"

        });

    }

    tabButtons.forEach(btn => {

        btn.addEventListener("click", function () {

            setTimeout(scrollActiveTab, 50);

        });

    });

    scrollActiveTab();

});

/*----- FAQ Tabs ---------*/
document.addEventListener("click", function(e){

    const btn = e.target.closest(".faq-question");

    if(!btn) return;

    const item = btn.closest(".faq-item");

    const answer = item.querySelector(".faq-answer");

    // Close other FAQs
    document.querySelectorAll(".faq-item").forEach(function(faq){

        if(faq !== item){

            faq.classList.remove("active");

            faq.querySelector(".faq-answer").style.maxHeight = null;

        }

    });

    item.classList.toggle("active");

    if(item.classList.contains("active")){

        answer.style.maxHeight = answer.scrollHeight + "px";

    }else{

        answer.style.maxHeight = null;

    }

});